import { t } from "i18next";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { useTwoColumnLayout } from "shared/core/hooks/useTwoColumnLayout";
import { MoodTrackerModule } from "../Home/components/MoodTrackerModule/MoodTrackerModule";
import { MoodChart } from "./components/MoodChart/MoodChart";
import { WellbeingToolTiles } from "../Resources/components/WellbeingToolTiles/WellbeingToolTiles";
import { ArticleCategoryList } from "../Resources/components/ArticleCategoryList/ArticleCategoryList";
import { WellKnownLearningMaterialCategories } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";

export const MoodInsights = () => {
  let componentList = [
    { content: <MoodTrackerModule hideYourInsights /> },
    {
      content: (
        <div className="space-y-4">
          <div>
            <h2>{t("resources.heading")}</h2>
            <p>{t("resources.headingParagraph")}</p>
          </div>
          <WellbeingToolTiles />
        </div>
      ),
    },
    { content: <MoodChart /> },
    {
      content: (
        <ArticleCategoryList
          heading={t("mood-insights.resources.title")}
          description={t("mood-insights.resources.description")}
          category={WellKnownLearningMaterialCategories.articles}
          ariaLabel={t("mood-insights.resources.ariaLabel")}
        />
      ),
    },
  ];
  const layout = useTwoColumnLayout(componentList, true);

  return (
    <>
      <PageTitle title={t("pageTitle.mood-insights")} />
      <PageHeader hideForMobile />
      {layout}
    </>
  );
};
